import styled from "styled-components";

import { grayScale, pink } from "@enkor/design/colors";

export const Page = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
`;

export const Container = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 16px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  width: 100%;
`;

export const LogoContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 8px;
  background-color: ${grayScale[300]};
  width: 120px;
  height: 120px;
`;

export const Logo = styled.div`
  position: relative;
  width: 99px;
  height: 36px;
`;

export const DownloadButton = styled.button`
  width: 100%;
  height: 56px;
  border-radius: 8px;
  background-color: ${pink.main};
  color: ${grayScale.white};
  font-size: 16px;
  font-weight: 600;

  cursor: pointer;
`;
